export const formatAUD = (value) => {
  if (value === null || value === undefined) return "Price on request";
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(value);
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phone: "+61 470368569",
  email: "shivleena@coreconnects.com.au",
  location: "Sydney, Australia",
  abn: "91921543692",
};

export const downloadInvoice = async (axios, order) => {
  const res = await axios.get(`${API}/orders/${order.id}/invoice`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `coreconnect-invoice-${order.order_number}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};
